<template>
   <div>
      <div
         class="tool-select-toggler"
         :class="{'selected': selected, 'open': open}"
         @click="handleClick"
         >
         <svg-icon :url="iconUrl" color="#eee"/>
         {{ label }}
      </div>
      <div class='inner-tool-select'>
         <div @click="open=false" class="close">&#10005;</div>
         <slot></slot>
      </div>
   </div>
</template>

<script>
import SvgIcon from '@/components/atoms/Home/SvgIcon';

export default {
   components: {
      SvgIcon,
   },
   props: {
      label: {
         type: String,
         required: true,
      },
      iconUrl: {
         type: String,
         required: true,
      },
      selected: {
         type: Boolean,
         required: true,
      },
   },
   data() {
      return {
         open: false,
      };
   },
   watch: {
      selected(isSelected)
      {
         if (!isSelected)
         {
            this.open = false;
         }
      },
   },
   methods: {
      handleClick()
      {
         this.open = !this.open;
         this.$emit('click');
      }
   }
}
</script>


<style lang="scss" scoped>
.tool-select-toggler {
      color: #eee;
      background: $primary-color;
      font-family: $primary-font;
      display: flex;
      font-size: 15px;
      padding: 8px;
      flex-direction: column;
      align-items: center;
      cursor: pointer;
      transition: transform 0.3s ease-in;
      border-radius: 1px;
      &.selected {
         background: lighten($primary-color, 10%);
         box-shadow: 0.1em 0.1em 0.3em rgba(black,0.4);
      }
      &:hover {
         background: tint($primary-color, 15%);
      }
   }

   .inner-tool-select {
      @include setBlurGlassBackground();
      position: absolute;
      width: 300px;
      top: 0px;
      z-index: -1;
      left: 0;
      padding: 5px;
      min-height: 90px;
      opacity: 0;
      display: flex;
      flex-direction: column;
      justify-content: center;
      transition: transform 0.8s ease-in-out, opacity 0.6s ease-in-out;

      > .close {
         @include flexCenter();
         color: $font-color;
         width: 1.5em;
         height: 1.5em;
         font-size: 0.9em;
         border-radius: 50%;
         position: absolute;
         left: 0;
         bottom: 0;
         border: 2px solid $light-color;
         transform: translate(-40%, 40%);
         cursor: pointer;
         background-color: rgba($light-color, 0.5);

         &:hover {
            background-color: rgba($primary-color, 0.1);
         }
      }
   }

   .tool-select-toggler.open.selected + .inner-tool-select
   // .tool-select-toggler:hover + .inner-tool-select,
   // .inner-tool-select:hover 
   {
      opacity: 1;
      transform: translateX(-100%);
   }
</style>